export const apiValidationMap: Record<string, string> = {
  'min.string': 'minLength',
  'max.string': 'maxLength',
  vehicle_required: 'hasRequiredVehicleDetails',
  posting_type_country_mismatch: 'postingTypeCountryMismatch',
  posting_type_not_allowed_eu_vat_percentage:
    'postingTypeNotAllowedEuVatPercentage',
  business_id: 'validBusinessID',
  ssn_validation: 'SSNValidation',
  vehicle_vat_class_allowance: 'vehicleVatClassAllowance',
  car_vat_class_allowance: 'carVatClassAllowance'
}

/**
 * Maps API validation keys to better matching client side validation names.
 */
export const mapValidationMessage = (message: string): string => {
  const key = message.replace('validation.', '')

  if (key in apiValidationMap) {
    return message.replace(key, apiValidationMap[key])
  }

  return message
}
